import { render, staticRenderFns } from "./OfferDetailClauses.vue?vue&type=template&id=3b8a7cc0"
import script from "./OfferDetailClauses.vue?vue&type=script&lang=js"
export * from "./OfferDetailClauses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports